// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { RecaptchaScoreError } from 'recaptcha/RecaptchaScoreError'
import { RecaptchaVerificationError } from 'recaptcha/RecaptchaVerificationError'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ExternalLinks } from 'constants/links'
import { LoginError, type LoginErrorType } from '../utils'

export interface LoginErrorProps {
  errorType: LoginErrorType
}

export const LoginErrorMessage = ({ errorType }: LoginErrorProps) => {
  const { t } = useTranslation()

  const contactSupportTextAction = (
    <ExternalLink href={ExternalLinks.CONTACT_SUPPORT}>
      {t('errorMessages.contactSupport')}
    </ExternalLink>
  )
  switch (errorType) {
    case LoginError.CREDENTIALS:
      return (
        <p className="text-body-regular text-inherit">{t('errorMessages.login.credentials')}</p>
      )

    case LoginError.FORBIDDEN:
      return (
        <>
          {`${t('errorMessages.login.default')} ${t('errorMessages.tryAgainLater')} `}
          {contactSupportTextAction}.
        </>
      )
    case LoginError.RECAPTCHA_LOW_SCORE:
      return <RecaptchaScoreError />
    case LoginError.RECAPTCHA_VERIFICATION:
      return <RecaptchaVerificationError />
    default:
      return null
  }
}
